// extracted by mini-css-extract-plugin
export default {"tag":"CategoryTag_tag__SFdCf","name":"CategoryTag_name__TymrU"};